module.exports = __webpack_public_path__ + "static/img/get-app-android-en.a04c865.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/get-app-android-en.svg
// module id = uueR
// module chunks = 0